export const DEFAULT_ITEM_HEIGHT = 32;
export const NUMBER_OF_ITEMS = 10;

// This includes the height of search bar (40px) and 8px padding top and bottom
export const SEARCH_BAR_HEIGHT_WITH_PADDING = 56;
